import { Component, OnInit, ElementRef, Input, OnChanges, ViewChild  } from '@angular/core';
import JsBarcode from 'jsbarcode';

@Component({
    selector: 'app-barcode',
    templateUrl: './barcode.component.html',
    styleUrls: ['./barcode.component.scss'],
    standalone: false
})
export class BarcodeComponent implements OnInit {
  @Input() value = '';
  @ViewChild('barcode', { static: true }) barcodeElement!: ElementRef<SVGSVGElement>;

  constructor() { }

  ngOnInit(): void {
  }

  showIcon = false;

  ngOnChanges() {
    if (this.value) {
      JsBarcode(this.barcodeElement.nativeElement, this.value, {
        format: 'CODE128',
        displayValue: true,
        fontSize: 12,
        height: 25
      });
    }
  }

  printThisBarcode(event: MouseEvent) {
    event.stopPropagation();

    const svgClone = this.barcodeElement.nativeElement.cloneNode(true) as SVGSVGElement;

    const win = window.open('', '', 'width=700,height=400');
    if (win) {
      win.document.write(`
        <html>
        <head>
          <title>Print Barcode</title>
          <style>
            @page {
              size: 50mm 30mm;  /* exact label size */
              margin: 0;
            }
            html, body {
              margin: 0;
              padding: 0;
              width: 50mm;
              height: 30mm;
              display: flex;
              align-items: center;
              justify-content: center;
              page-break-inside: avoid;
            }
            svg {
              width: 48mm;
              height: auto;
            }
          </style>
        </head>
        <body></body>
        </html>
      `);

      win.document.body.appendChild(svgClone);
      win.document.close();
      win.print();
      win.close();
    }
  }

}
